/**
 * InputBox component
 * Memoized, stable layout
 */
import React, { memo } from 'react';
import { Box, Text } from 'ink';
import TextInput from 'ink-text-input';

interface InputBoxProps {
    value: string;
    onChange: (value: string) => void;
    onSubmit: (value: string) => void;
    disabled?: boolean;
    focused?: boolean;
}

export const InputBox = memo<InputBoxProps>(({
    value,
    onChange,
    onSubmit,
    disabled = false,
    focused = true,
}) => (
    <Box borderStyle="round" borderColor="cyan" paddingX={1}>
        <Text color="cyan">❯ </Text>
        {!disabled ? (
            <TextInput
                value={value}
                onChange={onChange}
                onSubmit={onSubmit}
                placeholder="Type your message..."
                focus={focused}
            />
        ) : (
            <Text dimColor>Waiting...</Text>
        )}
    </Box>
));
